import { TabStyles } from '@tableau/widgets';
import * as React from 'react';


import { divWithStyle } from './LayoutComponents';
import {
  DataQualityDetailPanelMaxHeight,
  DataQualityDetailPanelWidth,
  DataQualityStatusChipBackgroundColor,
  DataQualityStatusChipSevereBackgroundColor,
  DataQualityStatusSevereTitleColor,
  DataQualityStatusTitleColor
} from './StyleConstants';
import { cssClass } from './StyleFunctions';

const Typography = TabStyles.Typography;
const Spacing = TabStyles.Spacing;
const Sizing = TabStyles.Sizing;

export const DataQualityStatusChipButtonStyle: React.CSSProperties = {
  cursor: 'pointer',
  display: 'inline-flex',
  alignItems: 'center',
  color: DataQualityStatusTitleColor,
  height: Sizing.RowHeight,
  fontSize: Typography.Sizing.Default,
  paddingLeft: Spacing.DefaultSpace,
  backgroundColor: DataQualityStatusChipBackgroundColor,
};

export const DataQualityStatusChipSevereButtonStyle: React.CSSProperties = {
  ...DataQualityStatusChipButtonStyle,
  color: DataQualityStatusSevereTitleColor,
  backgroundColor: DataQualityStatusChipSevereBackgroundColor
};

export const DataQualityStatusIconButtonStyle: React.CSSProperties = {
  padding: Spacing.SmallSpace,
  cursor: 'pointer',
};

export const DataQualityDetailPanelDialogStyle: React.CSSProperties = {
  width: DataQualityDetailPanelWidth,
  maxHeight: DataQualityDetailPanelMaxHeight,
};

export const DataQualityDetailPanelDialogBodyStyle: React.CSSProperties = {
  paddingTop: Spacing.LargeSpace,
  paddingBottom: 0,
  // Set the maximum height of both the dialog and its body for IE11 compatibility.
  maxHeight: DataQualityDetailPanelMaxHeight,
};

export const DataQualityDetailContentStyle: React.CSSProperties = {
  ...DataQualityDetailPanelDialogBodyStyle,
  paddingLeft: Spacing.LargeSpace,
  paddingRight: Spacing.LargeSpace,
  overflow: 'auto'
};

export const DataQualityDetailGroupHeadingDiv = divWithStyle('DataQualityDetailGroupHeadingDiv', {
  fontWeight: 'bold',
  marginBottom: Spacing.LargeSpace,
});

export const DataQualityDetailGroupDiv = divWithStyle('DataQualityDetailGroupDiv', {
  fontSize: Typography.Sizing.Default,
  paddingLeft: 9,
  width: 255,
});

export const DataQualityDetailGroupSpacerDiv = divWithStyle('DataQualityDetailGroupSpacerDiv', {
  height: 9
});

export const DataQualityDetailStyle = divWithStyle('DataQualityDetailDiv', {
  marginBottom: Spacing.LargeSpace,
});

export const DataQualityTooltipLabelClass = cssClass('DataQualityTooltipLabelClass', {
  color: DataQualityStatusTitleColor,
  paddingLeft: Spacing.DefaultSpace,
  paddingRight: Spacing.DefaultSpace,
});

export const DataQualityStatusChipIconOnlyClass = cssClass('DataQualityStatusChipIconOnlyClass', {
  verticalAlign: 'text-bottom',
  alignContent: 'left'
});

export const DataQualityStatusChipIconClass = cssClass('DataQualityStatusChipIconClass', {
  verticalAlign: 'text-bottom'
});

export const DataQualityDetailStatusChipStyle = divWithStyle('DataQualityDetailStatusChip', {
  marginBottom: Spacing.MediumSpace
});

export const DataQualityDetailAssetStyle = divWithStyle('DataQualityDetailAsset', {
  fontWeight: 'bold',
  color: Typography.Color.Primary,
  fontSize: Typography.Sizing.Default,
  marginTop: Spacing.DefaultSpace,
  marginBottom: Spacing.DefaultSpace,
  textOverflow: 'ellipsis',
  display: 'flex',
  whiteSpace: 'pre-wrap',
  overflow: 'hidden'
});

export const DataQualityDetailAuthorStyle = divWithStyle('DataQualityDetailAuthor', {
  color: Typography.Color.Primary,
  fontSize: Typography.Sizing.Default,
  marginBottom: Spacing.DefaultSpace,
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden'
});

export const DataQualityDetailDateStyle = divWithStyle('DataQualityDetailDate', {
  color: Typography.Color.Secondary,
  fontSize: Typography.Sizing.Default,
  marginBottom: Spacing.DefaultSpace
});

export const dataQualityDetailMessageStyle: React.CSSProperties = {
  width: 255,
  color: Typography.Color.Primary,
  fontSize: Typography.Sizing.Default,
};

export const DataQualityDetailMessageStyle = divWithStyle('DataQualityDetailMessage', {
  width: 255,
  color: Typography.Color.Primary,
  fontSize: Typography.Sizing.Default,
  $nest: {
    p: {
      marginTop: 0,
      marginBottom: 6, // TODO: 16?
    }
  }
});

export const DataQualityDetailPermissionRequired: React.CSSProperties = {
  color: 'rgba(0,0,0,0.56)',
};
